import styled, { keyframes } from 'styled-components'
import { HeightClass } from '~/utils/enum/classes'

import { Direction, Position } from '../enum'

export const Spinner = styled.div<{
  direction: Direction
  isBeforePositioned: boolean
  heightClass: HeightClass
  optionLabelsPosition: Position
}>`
  width: 16px;
  height: 16px;
  position: relative;
  ${({ theme, heightClass, isBeforePositioned, direction }) =>
    direction === 'horizontal'
      ? isBeforePositioned
        ? 'align-self: center; padding-top: 12px;'
        : 'align-self: initial; padding-top: 12px;'
      : isBeforePositioned
        ? `align-self: flex-end; margin-right: ${
            (theme.explicitSelectionButton[heightClass]?.width || 0) / 2 + 4
          }px;`
        : `align-self: initial; margin-left: ${
            (theme.explicitSelectionButton[heightClass]?.width || 0) / 2 + 4
          }px;`}
  ${({ optionLabelsPosition }) =>
    optionLabelsPosition === 'alternating'
      ? 'align-self: center; margin: 0; padding: 0'
      : ''}
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Svg = styled.svg`
  fill: #abbed1;
  animation: ${rotate} 2s linear infinite;
`
